import React from 'react';

export const DragContext = React.createContext({
  dragRef: null
});
